import { scaleLinear } from "d3";

class LinearScale {
  constructor(d1 = -1, d2 = -1, r1 = -1, r2 = -1) {
    this.d1 = d1;
    this.d2 = d2;
    this.r1 = r1;
    this.r2 = r2;
    this.start = d1;
    this.end = d2;
    this.scale = scaleLinear();
    this.calcValues();
  }

  static isEqual(a, b) {
    return a.d1 === b.d1 && a.d2 === b.d2 && a.r1 === b.r1 && a.r2 === b.r2;
  }

  calcValues() {
    this.start = this.d1 > this.d2 ? this.d2 : this.d1;
    this.end = this.d1 > this.d2 ? this.d1 : this.d2;
    this.rangeDist = this.r2 - this.r1;
    this.domainDist = this.end - this.start;
    this.rangeCenter = this.r1 + this.rangeDist / 2;
    this.scale.domain([this.d1, this.d2]);
    this.scale.range([this.r1, this.r2]);
    return this;
  }

  setValues({ d1, d2, r1, r2 } = {}) {
    this.d1 = d1 ?? this.d1;
    this.d2 = d2 ?? this.d2;
    this.r1 = r1 ?? this.r1;
    this.r2 = r2 ?? this.r2;
    this.calcValues();
    return this;
  }
}

export default LinearScale;
